import { useEffect, useRef } from "react";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

import { useEventCallback } from "../../../../hooks";

interface EditableStatePluginProps {
  editable: boolean;
  onEditableChange?: (editable: boolean) => void;
  onEditingComplete?: () => void;
}

export function EditableStatePlugin({
  editable,
  onEditableChange,
  onEditingComplete,
}: EditableStatePluginProps) {
  const [editor] = useLexicalComposerContext();
  const previousEditableRef = useRef(editable);

  const onEditableChangeEventCallback = useEventCallback(onEditableChange);
  const onEditingCompleteCallback = useEventCallback(onEditingComplete);

  useEffect(() => {
    const removeEditableListener = editor.registerEditableListener(
      onEditableChangeEventCallback,
    );
    return removeEditableListener;
  }, [editor, onEditableChangeEventCallback]);

  useEffect(() => {
    if (editor.isEditable() !== editable) {
      editor.setEditable(editable);
    }
  }, [editor, editable]);

  useEffect(() => {
    if (previousEditableRef.current && !editable) {
      onEditingCompleteCallback?.();
    }
    previousEditableRef.current = editable;
  }, [editable, onEditingCompleteCallback]);

  return null;
}
